<template>
  <footer class="py-5 bg-dark">
    <div class="container">
      <router-link to="/register">Register</router-link> |
      <router-link to="/about">About</router-link>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style></style>
